import {PropsWithChildren} from 'react';
import {StyledHeader} from './index.styled';

export function TestsPanelHeader({children}: PropsWithChildren) {
	return (
		<StyledHeader>
			{children}
		</StyledHeader>
	);
}